import { i18n } from '@/boot/i18n';

export const SURVEY_STATUS = {
  CREATING: 1,
  FINISHED: 2,
  DISPATCHED: 3,
  ARCHIVED: 4,
  EXPIRED: 5,
  UNAVAILABLE: 6,
  ANSWERED: 7,
};

export const BLOCKRULE_TYPE = {
  EMAIL: 0,
  PHONE: 1,
};

export const BLOCKRULE_TYPE_LABEL = {
  [BLOCKRULE_TYPE.EMAIL]: i18n.t('consts.blockrule.email'),
  [BLOCKRULE_TYPE.PHONE]: i18n.t('consts.blockrule.phone'),
};

export const BLOCKRULE_TYPE_OPTIONS = [
  { value: BLOCKRULE_TYPE.EMAIL, label: i18n.t('consts.blockrule.email') },
  { value: BLOCKRULE_TYPE.PHONE, label: i18n.t('consts.blockrule.phone') },
];

export const DISTRIBUTION_CHANNEL = {
  UNKNOWN: 0,
  WEB: 1,
  SMS: 2,
  EMAIL: 3,
  LINKSMS: 4,
  MESSAGE: 5,
  LINK: 6,
  QRCODE: 7,
  WHATSAPP: 8,
  WIDGET: 9,
  LINKLIST: 10,
};

export const DISTRIBUTION_CHANNEL_LABEL = {
  [DISTRIBUTION_CHANNEL.UNKNOWN]: i18n.t('consts.distribution.unknow'),
  [DISTRIBUTION_CHANNEL.WEB]: i18n.t('consts.distribution.web'),
  [DISTRIBUTION_CHANNEL.SMS]: i18n.t('consts.distribution.sms'),
  [DISTRIBUTION_CHANNEL.EMAIL]: i18n.t('consts.distribution.email'),
  [DISTRIBUTION_CHANNEL.LINKSMS]: i18n.t('consts.distribution.link_sms'),
  [DISTRIBUTION_CHANNEL.MESSAGE]: i18n.t('consts.distribution.message'),
  [DISTRIBUTION_CHANNEL.LINK]: i18n.t('consts.distribution.link'),
  [DISTRIBUTION_CHANNEL.QRCODE]: i18n.t('consts.distribution.qr_code'),
  [DISTRIBUTION_CHANNEL.WHATSAPP]: i18n.t('consts.distribution.whatsapp'),
  [DISTRIBUTION_CHANNEL.WIDGET]: i18n.t('consts.distribution.widget'),
  [DISTRIBUTION_CHANNEL.LINKLIST]: i18n.t('consts.distribution.linklist'),
};

export const DISTRIBUTION_STATUS = {
  CREATED: 0,
  PROCESSING: 1,
  FINISHED: 2,
  REMINDPROCESSING: 3,
  REMINDFINISHED: 4,
  EXPIRED: 5,
  PROCESSINGLINKS: 6,
  LINKSPROCESSED: 7,
};

export const DISTRIBUTION_SENDER_TYPE = {
  SFTP: 1,
  API: 2,
};

export const QUESTION_TYPE = {
  CES: 1,
  CSAT: 2,
  EMOJI: 3,
  MULTIPLE_CHOICE: 4,
  NPS_RELATIONAL: 5,
  NPS_TRANSACTIONAL: 6,
  OPEN: 7,
  RATINGS: 8,
  THUMBS: 9,
  LABEL: 10,
  IMAGE: 11,
  CES2: 12,
};

export const QUESTION_SCALE_TYPE = {
  CES: {
    NUMERIC: 0,
    LIKERT: 1,
    TEXTUAL: 2,
  },
  CSAT: {
    NUMERIC: 0,
    LIKERT: 1,
  },
};

export const QUESTION_TYPE_LABEL = {
  [QUESTION_TYPE.CES]: 'survey.question_type.ces_1',
  [QUESTION_TYPE.CES2]: 'survey.question_type.ces_2',
  [QUESTION_TYPE.CSAT]: 'survey.question_type.csat',
  [QUESTION_TYPE.EMOJI]: 'survey.question_type.emoji',
  [QUESTION_TYPE.MULTIPLE_CHOICE]: 'survey.question_type.multiple_choice',
  [QUESTION_TYPE.NPS_RELATIONAL]: 'survey.question_type.nps_relational_short',
  [QUESTION_TYPE.NPS_TRANSACTIONAL]: 'survey.question_type.nps_transactional_short',
  [QUESTION_TYPE.OPEN]: 'survey.question_type.open',
  [QUESTION_TYPE.RATINGS]: 'survey.question_type.ratings',
  [QUESTION_TYPE.THUMBS]: 'survey.question_type.thumbs',
  [QUESTION_TYPE.LABEL]: 'survey.question_type.title',
  [QUESTION_TYPE.IMAGE]: 'survey.question_type.image',
};

export const CES_LIKERT_5 = {
  STRONGLY_DISAGREE: 1,
  DISAGREE: 2,
  NEUTRAL: 3,
  AGREE: 4,
  STRONGLY_AGREE: 5,
};

export const CES_LIKERT_5_LABEL = {
  [CES_LIKERT_5.STRONGLY_DISAGREE]: () => i18n.t('survey.likert.strongly_disagree'),
  [CES_LIKERT_5.DISAGREE]: () => i18n.t('survey.likert.disagree'),
  [CES_LIKERT_5.NEUTRAL]: () => i18n.t('survey.likert.neutral'),
  [CES_LIKERT_5.AGREE]: () => i18n.t('survey.likert.agree'),
  [CES_LIKERT_5.STRONGLY_AGREE]: () => i18n.t('survey.likert.strongly_agree'),
};

export const CES_LIKERT_7 = {
  STRONGLY_DISAGREE: 1,
  DISAGREE: 2,
  SOMEWHAT_DISAGREE: 3,
  NEUTRAL: 4,
  SOMEWHAT_AGREE: 5,
  AGREE: 6,
  STRONGLY_AGREE: 7,
};

export const CES_LIKERT_7_LABEL = {
  [CES_LIKERT_7.STRONGLY_DISAGREE]: () => i18n.t('survey.likert.strongly_disagree'),
  [CES_LIKERT_7.DISAGREE]: () => i18n.t('survey.likert.disagree'),
  [CES_LIKERT_7.SOMEWHAT_DISAGREE]: () => i18n.t('survey.likert.somewhat_disagree'),
  [CES_LIKERT_7.NEUTRAL]: () => i18n.t('survey.likert.neutral'),
  [CES_LIKERT_7.SOMEWHAT_AGREE]: () => i18n.t('survey.likert.somewhat_agree'),
  [CES_LIKERT_7.AGREE]: () => i18n.t('survey.likert.agree'),
  [CES_LIKERT_7.STRONGLY_AGREE]: () => i18n.t('survey.likert.strongly_agree'),
};

export const CSAT_LIKERT = {
  EXTREMELY_UNSATISFIED: 1,
  UNSATISFIED: 2,
  NEUTRAL: 3,
  SATISFIED: 4,
  EXTREMELY_SATISFIED: 5,
};

export const CSAT_LIKERT_LABEL = {
  [CSAT_LIKERT.EXTREMELY_UNSATISFIED]: () => i18n.t('survey.likert.extremely_unsatistied'),
  [CSAT_LIKERT.UNSATISFIED]: () => i18n.t('survey.likert.unsatisfied'),
  [CSAT_LIKERT.NEUTRAL]: () => i18n.t('survey.likert.neutral'),
  [CSAT_LIKERT.SATISFIED]: () => i18n.t('survey.likert.satisfied'),
  [CSAT_LIKERT.EXTREMELY_SATISFIED]: () => i18n.t('survey.likert.extremely_satistied'),
};

export const CES_TEXTUAL_5 = {
  VERY_HARD: 1,
  HARD: 2,
  NEUTRAL: 3,
  EASY: 4,
  VERY_EASY: 5,
};

export const CES_TEXTUAL_5_LABEL = {
  [CES_TEXTUAL_5.VERY_HARD]: () => i18n.t('survey.textual.very_hard'),
  [CES_TEXTUAL_5.HARD]: () => i18n.t('survey.textual.hard'),
  [CES_TEXTUAL_5.NEUTRAL]: () => i18n.t('survey.textual.neutral'),
  [CES_TEXTUAL_5.EASY]: () => i18n.t('survey.textual.easy'),
  [CES_TEXTUAL_5.VERY_EASY]: () => i18n.t('survey.textual.very_easy'),
};

export const CES_TEXTUAL_7 = {
  EXTREMELY_HARD: 1,
  VERY_HARD: 2,
  HARD: 3,
  NEUTRAL: 4,
  EASY: 5,
  VERY_EASY: 6,
  EXTREMELY_EASY: 7,
};

export const CES_TEXTUAL_7_LABEL = {
  [CES_TEXTUAL_7.EXTREMELY_HARD]: () => i18n.t('survey.textual.extremely_hard'),
  [CES_TEXTUAL_7.VERY_HARD]: () => i18n.t('survey.textual.very_hard'),
  [CES_TEXTUAL_7.HARD]: () => i18n.t('survey.textual.hard'),
  [CES_TEXTUAL_7.NEUTRAL]: () => i18n.t('survey.textual.neutral'),
  [CES_TEXTUAL_7.EASY]: () => i18n.t('survey.textual.easy'),
  [CES_TEXTUAL_7.VERY_EASY]: () => i18n.t('survey.textual.very_easy'),
  [CES_TEXTUAL_7.EXTREMELY_EASY]: () => i18n.t('survey.textual.extremely_easy'),
};

export const EMOJI_ANSWERS = {
  1: 'survey/emoji/report/verysad.svg',
  2: 'survey/emoji/report/sad.svg',
  3: 'survey/emoji/report/neuter.svg',
  4: 'survey/emoji/report/smile.svg',
  5: 'survey/emoji/report/happy.svg',
};
